import useCursorMovePosition from './use-cursor-move-position';
import './cursor-move-tip.less';

const CursorMoveTip: React.FC<{
    elemId: string;
    text: string;
    cursorDistance?: number;
    hide?: boolean;
}> = ({ elemId, text, cursorDistance = 24, hide = false }) => {
    const position = useCursorMovePosition(elemId);

    if (!position) {
        return null;
    }

    return (
        <div
            className="c-CursorMoveTip"
            style={{
                left: `${position.x + cursorDistance}px`,
                top: `${position.y - 14}px`,
                visibility: hide ? 'hidden' : 'visible',
            }}
        >
            <span>{text}</span>
        </div>
    );
};

export default CursorMoveTip;
